<template>
  <div class="menu-controls">
    <ul>
      <li class="item-menu-holding">
        <a @click="routerNewOffer" class="menu">
          <img src="../../../assets/img/icons8-plus-120.png" alt=""/>
          <span class="w-100">{{ $t("DashboardPageManager.menu_links.create_offer") }}</span>
        </a>
      </li>
      <li class="item-menu-holding">
        <span @click="addUserEvent">
          <router-link :to="routerCreateCandidate" class="menu">
            <img src="../../../assets/img/icons8-medical-doctor-80.png"  alt=""/>
            <span class="w-100">{{ $t("DashboardPageManager.menu_links.create_candidate") }}</span>
          </router-link>
        </span>
      </li>
      <li class="item-menu-holding">
        <a :href=externalLinks.support class="menu" @click="contactSupport" target="_blank">
          <img src="../../../assets/img/icons8-ask-question-80.png"  alt=""/>
          <span class="w-100">{{ $t("DashboardPageManager.menu_links.contact_support") }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import {mapActions} from "vuex";
  import { externalLinks } from '@/settings/externalLinks';
  import AtInternetManagingCandidate from '@/helpers/at_internet/managing_candidate'
  import AtInternetManager from '@/helpers/at_internet/manage_requests'
  import { sendContactSupportEvent } from '@/helpers/at_internet/help_manager'
  
  export default {
    name: 'Menu',
    props: ['entityId', 'entity'],
    computed: {
      routerCreateCandidate() {
        return this.entityId ? { name: 'NewUser', params: { entity_id: this.entityId } } : {name: 'Users'}
      },
      externalLinks() {
        return externalLinks
      }
    },
    methods: {
      ...mapActions({
        setLoadForm: 'offers/setLoadForm',
        setEntityOffer: 'offers/setEntityOffer',
        reset: 'offers/reset'
      }),
      routerNewOffer() {
        if (this.entityId) {
          this.setEntityOffer(this.entity)
          this.setLoadForm(true);
        } else {
          this.reset()
          this.setLoadForm(false);
        }
        AtInternetManager.sendCreateRequestEvent();
        this.$router.push({ name: 'NewOffer' })
      },
      addUserEvent(){
        AtInternetManagingCandidate.sendAskAddCandidatEvent()
      },
      contactSupport() {
        sendContactSupportEvent()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/manager/Menu.vue